export interface ITeacherDTO {
  id: string;
  name: string;
}

export class TeacherDTO implements ITeacherDTO {
  id: string = '';
  name: string = '';

  constructor(configOverride?: Partial<ITeacherDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
